export enum ProjectCode {
  SevenDays = '7days',
  UKCC = 'ukcarp',
  Default = 'default'
}
